import {chain} from 'lodash';

import {
  ApplicationChannelList,
  ApplicationPaginationToken,
} from '../../../applications/bridge/v2/types/bridgeTypesV2';
import {serializeChannelForApplication} from '../../../helpers/models/applicationSerializationHelpers';
import {ThunkAction} from '../../appThunk';
import {getUserParticipatingChannels} from '../channels/channelsSelectors';

/*
 * Actions.
 */

export function applicationListChannelsAction(
  _paginationToken?: ApplicationPaginationToken,
): ThunkAction<ApplicationChannelList> {
  return (_dispatch, getState) => {
    const channels = getUserParticipatingChannels(getState());
    const {data} = getState();

    const results = chain(channels)
      .map((channel) => serializeChannelForApplication(data, channel))
      .compact()
      .value();

    return {
      nextPageToken: undefined,
      results,
    };
  };
}
